import { FC } from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export interface TermsAndConditionsIconProps {
  color: string;
}

export const TermsAndConditionsIcon: FC<TermsAndConditionsIconProps> = ({ color }) => {
  return (
    <SvgIcon>
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M13.1919 2.05225V7.05225H18.1919'
          stroke={color}
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M15.1919 12.0522H7.19189'
          stroke={color}
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M13.1919 16.0522H7.19189'
          stroke={color}
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M9.19189 8.05225H8.19189H7.19189'
          stroke={color}
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.61047 1C4.16875 1 3 2.16874 3 3.61047V18.4942C3 19.9359 4.16875 21.1047 5.61047 21.1047H13.8534C13.5478 20.6548 13.3189 20.1485 13.1857 19.6047H5.61047C4.99717 19.6047 4.5 19.1075 4.5 18.4942V3.61047C4.5 2.99717 4.99717 2.5 5.61047 2.5H12.7417L17.8837 7.64206V13.8465C18.4109 13.8665 18.9157 13.9744 19.3837 14.1558V7.3314C19.3837 7.13248 19.3047 6.94172 19.1641 6.80106L13.5827 1.21967C13.442 1.07902 13.2512 1 13.0523 1H5.61047Z'
          fill='white'
        />
        <path
          d='M17.3443 22.6886C19.7436 22.6886 21.6886 20.7436 21.6886 18.3443C21.6886 15.945 19.7436 14 17.3443 14C14.945 14 13 15.945 13 18.3443C13 20.7436 14.945 22.6886 17.3443 22.6886Z'
          stroke={color}
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M15.5674 18.5419L17.0484 19.7267L19.2699 17.209'
          stroke={color}
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </SvgIcon>
  );
};
